import {Stack} from '@mui/material'
import React, {useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'
import TitlePage from '../customTable/TitlePage'
import InputWithLabel from '../customTable/LabelWithText'
import MainBtn from '../customTable/MainBtn'
import WalletPage from '../../svg/WalletPage'
import Label from '../customTable/Label'
import WalletApi from '../../Api/wallet'
import {useLocation} from 'react-router-dom'
import {toast} from 'react-toastify'
import PopUp from '../customTable/PopUp'
import {useSelector} from 'react-redux'
import {RootState} from '../../store'
import {useDispatch} from 'react-redux'
import {actions} from '../../store/vender/Auth/auth.slice'
import ConnectedWallet from '../../svg/ConnectedWallet'

export default function Wallet() {
  // KoninPay is discontinued — hide the connect banner until A-7 payment gateway is wired
  return null

  // eslint-disable-next-line no-unreachable
  const {t} = useTranslation()
  const [isConnect, setIsConnect] = useState(!true)
  const [isLoading, setIsLoading] = useState(false)
  const location = useLocation()
  const [queryParams, setQueryParams] = useState({})
  const {sizeImages} = useSelector((state: RootState) => state.vender)
  const dispatch = useDispatch()

  // useEffect(() => {
  //   const searchParams = new URLSearchParams(location.search)

  //   const params = Object.fromEntries(searchParams.entries())
  //   if (params.status === 'SUCCESS') {
  //     dispatch(
  //       actions.setImagesSize({
  //         ...sizeImages,
  //         pay: {
  //           ...sizeImages.pay,
  //           is_link_pay: true,
  //         },
  //       })
  //     )
  //     localStorage.setItem('pay', 'true')
  //     toast.success(t(params.message))
  //   } else if (params.status === 'ERROR') {
  //     toast.error(t(params.message))
  //   }

  //   setQueryParams(params)
  // }, [location.search])
  const bannerInfo = {
    title: t('MyWallet'),
    home: t('home'),
    linkHome: '/',
  }
  const [isChange, setIsChange] = useState(false)
  return (
    <Stack height={'100%'}>
      <TitlePage info={bannerInfo} />
      <Stack
        width='100%'
        gap='24px'
        justifyContent={'center'}
        alignItems={'center'}
        mt='21px'
        bgcolor={'#fff'}
        p='32px'
        borderRadius={'8px'}
        height={'100%'}
      >
        {sizeImages.pay && sizeImages.pay.is_link_pay ? <ConnectedWallet /> : <WalletPage />}
        <Stack>
          <Label
            align='center'
            mw='279px'
            fw='600'
            fs={sizeImages.pay && sizeImages.pay.is_link_pay ? '14px' : '17px'}
            text={
              sizeImages.pay && sizeImages.pay.is_link_pay ? 'connectedWallet' : 'connectWallet'
            }
          />
          <Label
            align='center'
            mw='279px'
            fw='600'
            fs={sizeImages.pay && sizeImages.pay.is_link_pay ? '14px' : '17px'}
            text={sizeImages.pay && sizeImages.pay.account_number}
          />
        </Stack>

        <MainBtn
          isLoading={isLoading || isChange}
          handelSubmit={() => {
            WalletApi.post(
              {callback: window.location.href},
              (res: any) => {
                setIsChange(true)
                window.location.href = res.redirect_url
              },
              setIsLoading
            )
          }}
          width='auto'
          text={sizeImages.pay && sizeImages.pay.is_link_pay ? 'changeWallet' : 'connect'}
        />
      </Stack>
      <PopUp open={isChange} width='xs'>
        <Stack p='24px' bgcolor={'#fff'}>
          <Label align='center' text='ChangeWalletMsg' />
        </Stack>
      </PopUp>
    </Stack>
  )
}
